import useSWRImmutable from 'swr/immutable';
import { groupMembeRakeback } from '@/helpers/user';
import { fetcherSS } from '@/modules/api';
import { useGetCommonStore } from '@/store';

export interface IRakeback {
  currency: string;
  amountCents: number;
  amountCentsDecimal: string;
}

export const usePlayerRakebacks = () => {
  const useCommonStore = useGetCommonStore();
  const user = useCommonStore.use.user();

  const shouldFetch = groupMembeRakeback(user);

  const {
    data = [],
    error,
    isLoading,
  } = useSWRImmutable<IRakeback[]>(
    shouldFetch ? '/player/rakebacks' : null,
    fetcherSS
  );

  return {
    data,
    error,
    isLoading,
  };
};
